module.exports = __webpack_public_path__ + "static/img/focusCode@2x1.45b926f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/footer/focusCode@2x1.jpg
// module id = 9Kyj
// module chunks = 22